import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../_services/session/session.service';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { map, take } from 'rxjs';


export const authGuard: CanActivateFn = (_route, _state) => {
  const sessionService: SessionService = inject(SessionService);
  const toastr: ToastrService = inject(ToastrService);

  return sessionService.sessionData$.pipe(
    take(1),
    map((sessionData: any) => {
      if (sessionData && sessionData.isAuthenticated) {
        return true;
      } else {
        toastr.error('You shall not pass!');
        return false;
      }
    })
  );
};


export const adminGuard: CanActivateFn = (_route, _state) => {
  const sessionService: SessionService = inject(SessionService);
  const toastr: ToastrService = inject(ToastrService);
  const router: Router = inject(Router);

  return sessionService.sessionData$.pipe(
    take(1),
    map((sessionData: any) => {
      if (!sessionData || !sessionData.isAuthenticated) {
        router.navigate(['/auth/login']);
        return false;
      }

      const userRole = sessionData.user?.role?.toLowerCase();
      if (userRole === 'admin' || userRole === 'administrator' || userRole === 'super_admin') {
        return true;
      } else {
        toastr.error('Access denied! Admin privileges required.');
        router.navigate(['/landing-page']);
        return false;
      }
    })
  );
};


export const redirectIfAuthenticated: CanActivateFn = (_route, _state) => {
  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);

  return sessionService.sessionData$.pipe(
    take(1),
    map((sessionData: any) => {
      if (sessionData && sessionData.isAuthenticated) {
        router.navigate(['/admin/dashboard']);
        return false;
      }
      return true;
    })
  );
};

export const userGuard: CanActivateFn = (_route, _state) => {
  return true;
};


export const verifyAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const nav = router.getCurrentNavigation();

  const comingFromForgot = nav?.extras?.state?.['fromForgot'];

  if (!comingFromForgot) {
    router.navigate(['/auth/forgot-password']);
    return false;
  }

  return true;
};
export const resetAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Pull navigation state safely
  const navState = history.state;

 const nav = router.getCurrentNavigation();

  const email = nav?.extras?.state?.['email'];
  const code = nav?.extras?.state?.['code'];
  // If email and code exist → allow access
  if (navState && email && code) {
    return true;
  }
  // Otherwise → Redirect user back to forgot-password
  return router.createUrlTree(['/auth/forgot-password']);
};